<template>
    <div>
        <b-row align-h="between" class="mb-3">
            <b-col cols="auto">
                <el-button type="text" class="py-0" @click="backToProperty">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 320 512"><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
                    View Property Details
                </el-button>
            </b-col>
            <!-- <b-col cols="auto" class="d-flex align-items-center" v-if="current_product_data && typeof current_product_data === 'object'">
                <el-dropdown trigger="click" class="cursor-pointer text-primary" v-if="project && project.project_files.length > 0">
                    <span class="el-dropdown-link font-weight-500">
                        Download
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>Brochure</el-dropdown-item>
                        <el-dropdown-item v-if="hasBookingFile" @click.native="downloadBookingForm">Booking Form</el-dropdown-item>
                        <el-dropdown-item>Unit Price</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="text" class="py-0 ml-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v139.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64zm384 64H256V0zm165.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0M311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"/></svg>
                    Generate E-sign Link
                </el-button>
            </b-col> -->
        </b-row>
        <div v-if="current_product_data && typeof current_product_data === 'object'">
            <b-row>
                <b-col cols="12" lg="8" v-if="unit">
                    <BookingSummaryTable :project="project" :unit="unit" :unit_fees="unit.unit_fees" :unit_setting="unit.unit_setting" />
                </b-col>
                <b-col cols="12" lg="4">
                    <PropertyInfo :project="project" :unit="unit" :customer="customer" />
                    <div class="my-3" v-if="unit">
                        <div class="d-flex align-items-center">
                            <span class="text-muted mr-1">Floor Plan:</span>
                            <p class="font-weight-500">{{ unit.unit_type.unit_type_name }}</p>
                        </div>
                        <b-img 
                            v-if="unit.unit_type.floor_plan_image_url"
                            class="border rounded" 
                            :src="unit.unit_type.floor_plan_image_url" 
                            fluid alt="Responsive image" 
                        />
                    </div>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mb-3">
                <b-col cols="6" class="text-center">
                    <b-button variant="primary" class="w-50" @click="bookUnit">Book</b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import BookingSummaryTable from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/UnitDetails/BookingSummary'
import PropertyInfo from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/UnitDetails/PropertyInfo'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
} from '@/assets/js/httpImports.js'

export default {
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        BookingSummaryTable,
        PropertyInfo,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            customer: {},
            project: {},
            unit: {},
            booking_file: {}
        }
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data']),
        async hasBookingFile() {
            const bookingFile = await this.project.project_files.find(file => file.original_file_name.toLowerCase().includes('booking'))
            if (bookingFile) {
                this.booking_file = bookingFile
                return true
            }
            return false
        }
    },
    watch: {
        current_product_data: {
            handler(newValue) {
                this.customer = newValue.current_customer
                this.unit = newValue.unit
                this.project = newValue.project
            }
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createPropertyProduct', 'createPropertyRentalProduct']),
        backToProperty() {
            solutionEventBus.$emit('show-property-selections')
        },
        downloadBookingForm() {
            console.log(this.booking_file)
        },
        async bookUnit() {
            if (this.project.project_stage_id !== 4) {
                solutionEventBus.$emit('show-bank-selections')
            } else {
                try{
                    await this.createPropertyRentalProduct()
                    this.notifySuccess('<b>Draft </b> - Successfully Created.')
                    solutionEventBus.$emit('show-summary-selections')
                }catch(e){
                    this.errorFunction(null, e)
                }
            }
        }
    }
}
</script>